import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { WMICDateTimeService } from 'wmic-pe-portals-utils-js';
import { WMICListDownloadButton } from 'wmic-pe-components-platform-react';
import WMICPolicyHistoryDetailView from './WMICPolicyHistoryDetailView/WMICPolicyHistoryDetailView';

import WMICDashDetailView from './WMICDashDetailView/WMICDashDetailView';
import metadata from './WMICPolicyPADriverPolicyHistoryComponent.metadata.json5';

import messages from './WMICPolicyPADriverPolicyHistoryComponent.messages.js';
import { TranslatorContext } from '@jutro/legacy/locale';

function WMICPolicyPADriverPolicyHistoryComponent(props) {
    const { driverVM, policyVM } = props;

    const translator = useContext(TranslatorContext);

    const claimsHistoryLetterOfExperienceHeader = useMemo(() => {
        const autoPlusLabelCondition = _.get(driverVM, `autoPlusLabelCondition_WMIC.aspects.ocular`);
        return translator(autoPlusLabelCondition ? messages.claimHistoryReportHeading : messages.autoPlusHeading);
    }, [driverVM, translator]);

    const claimsHistoryLetterOfExperienceDateLabel = useMemo(() => {
        const autoPlusLabelCondition = _.get(driverVM, `autoPlusLabelCondition_WMIC.aspects.ocular`);
        return translator(autoPlusLabelCondition ? messages.claimHistoryReportDate : messages.autoPlusDate);
    }, [driverVM, translator]);

    const getDateElement = date => <span>{WMICDateTimeService.toMidnightDate(date)}</span>;

    const displayDashRequestedDate = lossHistoryEntry => {
        const lostHistoryDateRequested = lossHistoryEntry.value.dateRequested;
        return lostHistoryDateRequested ? getDateElement(lostHistoryDateRequested) : '';
    };

    const displayDashRetreivedDate = lossHistoryEntry => {
        const lostHistoryDateRetreived = lossHistoryEntry.value.dateReceived;
        return lostHistoryDateRetreived ? getDateElement(lostHistoryDateRetreived) : '';
    };

    const isCommercialAuto = policyVM?.lobs?.personalAuto?.isCommercialAutoIndicator_Ext?.value;

    const previousInsuranceHeadingTitle = translator(
        isCommercialAuto
            ? messages.previousInsuranceHeadingForCommercialAuto
            : messages.previousInsuranceHeadingForNonCommercialAuto
    );

    const overrideProps = {
        '@field': {
            parentNode: driverVM,
            readOnly: true,
        },
        previousInsuranceSectionHeading: {
            title: previousInsuranceHeadingTitle,
        },
        policyListView: {
            VMData: [
                {
                    headerText: translator(messages.insurerName),
                    path: 'carrierName',
                },
                {
                    headerText: translator(messages.policy),
                    path: 'policyNumber',
                },
                {
                    headerText: translator(messages.riskType),
                    path: 'riskType',
                },
            ],
            clickable: true,
            readOnly: true,
            detailViewComponent: WMICPolicyHistoryDetailView,
            renderAddButton: false,
            startOpen: false,
        },
        dashListView: {
            VMData: [
                {
                    headerText: translator(messages.dateRequested),
                    getData: displayDashRequestedDate,
                },
                {
                    headerText: translator(messages.dateReceived),
                    getData: displayDashRetreivedDate,
                },
                {
                    headerText: translator(messages.orderStatus),
                    path: 'orderStatus',
                },
                {
                    headerText: translator(messages.source),
                    path: 'sourceSystem',
                },
            ],
            clickable: true,
            readOnly: true,
            detailViewComponent: WMICDashDetailView,
            renderAddButton: false,
            startOpen: false,
            customElement: WMICListDownloadButton,
        },
        autoPlusHeading: {
            title: claimsHistoryLetterOfExperienceHeader,
        },
        dateAutoPlusOrderedField: {
            label: claimsHistoryLetterOfExperienceDateLabel,
        },
    };

    const resolvers = {
        resolveComponentMap: {
            WMICPolicyHistoryDetailView,
            WMICDashDetailView,
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={driverVM}
            overrideProps={overrideProps}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

WMICPolicyPADriverPolicyHistoryComponent.propTypes = {
    driverVM: PropTypes.shape({}).isRequired,
};

export default WMICPolicyPADriverPolicyHistoryComponent;
